<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	import { localReq, postReq } from '../../../../services/http';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';
	//Helpers
	import { get_local_ip } from '../../../../helpers/interface_helpers';

	export let device;

	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;

	let valueOpen = $settingsStore['rollers'][device.channel].maxtime_open;
	let cacheOpen = valueOpen;
	let valueClose = $settingsStore['rollers'][device.channel].maxtime_close;
	let cacheClose = valueClose;
	let loading = false;
	const min = 0;
	const max = 120;

	let local_ip = get_local_ip(device.id);

	const set_blind_time = async () => {
		if (cacheOpen !== valueOpen || cacheClose !== valueClose) {
			let res: any = {};
			loading = true;
			if (local_ip) {
				let req_open = await localReq(
					device,
					`${local_ip}/settings/${device.category}/0`,
					'post',
					{
						maxtime_open: valueOpen,
					},
				);
				let req_close = await localReq(
					device,
					`${local_ip}/settings/${device.category}/0`,
					'post',
					{
						maxtime_close: valueClose,
					},
				);
				if (req_open.isok && req_close.isok) {
					res.isok = true;
					cacheOpen = valueOpen;
					cacheClose = valueClose;
				} else {
					toast.open({ type: 'danger', title: $format('error_global') });
					valueOpen = cacheOpen;
					valueClose = cacheClose;
				}
			} else {
				res = await postReq(`/device/relay/roller/settings/maxtime`, {
					roller_id: device.channel,
					maxtime_open: valueOpen,
					maxtime_close: valueClose,
					id: device.id,
				});
			}

			if (res.isok) {
				settings['rollers'][device.channel].maxtime_open = valueOpen;
				settings['rollers'][device.channel].maxtime_close = valueClose;
				toast.open({
					type: 'success',
					title: $format('setting_scc_saved_toast'),
				});
				devices_settings.update_devices_settings(device.id, settings);
				cacheOpen = valueOpen;
				cacheClose = valueClose;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				valueOpen = cacheOpen;
				valueClose = cacheClose;
			}
			loading = false;
		}
	};
</script>

<Text styleType="body-small" class="mb-s"
	>{$format('description_for_opening_working_time', {
		values: { value: valueOpen, min, max },
	})}
</Text>
<Input
	size="m"
	class="mb-s"
	bind:value={valueOpen}
	type={'number'}
	{min}
	{max}
	on:enter={set_blind_time}
	id="input-mszobcg"
	aria-label={$format('description_for_opening_working_time', {
		values: { value: valueOpen, min, max },
	})}
/>

<Text styleType="body-small" class="mb-s">
	{$format('description_for_closing_working_time', {
		values: { value: valueClose, min, max },
	})}
</Text>
<Input
	size="m"
	class="mb-s"
	bind:value={valueClose}
	type={'number'}
	{min}
	{max}
	on:enter={set_blind_time}
	id="input-ylpwagb"
	aria-label={$format('description_for_closing_working_time', {
		values: { value: valueClose, min, max },
	})}
/>

<Button class="mt-s" {loading} size="m" width="full" on:click={set_blind_time}
	>{$format('button_save')}</Button
>
